import { issueExchangeStatusOptions } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/constants'

export const getAvailableIssueExchangeStatus = availableStatus => {
  if (!availableStatus) return issueExchangeStatusOptions
  return issueExchangeStatusOptions.filter(option => availableStatus.includes(option.value))
}
